import { render } from "./OrderQueryDetails.vue?vue&type=template&id=31f9194d&scoped=true"
import script from "./OrderQueryDetails.vue?vue&type=script&lang=js"
export * from "./OrderQueryDetails.vue?vue&type=script&lang=js"

import "./OrderQueryDetails.vue?vue&type=style&index=0&id=31f9194d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f9194d"]])

export default __exports__